<template>
  <div class='profession_con hezuo_con'>
    <div class='pub_top_block w_1200'>
      <dl>
        <dt>
          <h3 class='pub_tit'>{{ $t('profession.title') }}</h3>
          <div class='text' v-html='$t("profession.desc")'></div>
        </dt>
      </dl>
      <img src='@/assets/img/profession/banner1.png' alt='' class='profession_banner'>
    </div>
    <div v-for='(item, index) in list' :key='index' :class='`item${index + 1} block block${index % 2 !== 0 ? 4 : 3}`'>
      <h3 class='pub_tit pub_tit_common' v-if='item.titleCommon'>{{ item.titleCommon }}</h3>
      <div class='w_1200 cf'>
        <div class='profession_list_info fr'>
          <div class='pub_tit'>{{ item.title }}</div>
          <img v-if='item.bannerSub' class='info_banner' :src='item.bannerSub' alt=''>
          <div v-if='item.desc' class='info text_center' v-html='item.desc'></div>
          <ul class='text_center'>
            <li v-for='(imgItem, imgIndex) in item.list' :key='imgIndex' class='img_box'>
              <img :src='imgItem.image' alt='banner'>
              <div class='info_item'>
                <p class='text'>{{ imgItem.title }}</p>
                <p v-if='imgItem.desc' class='desc'>{{ imgItem.desc }}</p>
              </div>
            </li>
          </ul>
          <div v-if='index === 1 || index === 2' class='ellipsis'>...</div>
        </div>
        <img v-if='item.banner' class='profession_list_banner fl' :src='item.banner' alt=''>
        <!--        <img class='profession_list_banner' :src='item.banner' alt='' v-if='item.banner && device === "mobile"'>-->
      </div>
    </div>
  </div>
</template>

<script>
import { mediaDevice, setTitle } from 'utils'
export default {
  name: 'BusinessCooperate',
  data () {
    return {
      device: mediaDevice(),
    }
  },
  computed: {
    list () {
      // 不根据语言版切换的初始数据
      let list = [
        {
          banner: '',
          list: [
            { image: require('@/assets/img/profession/service1.png') },
            { image: require('@/assets/img/profession/service2.png') },
            { image: require('@/assets/img/profession/service3.png') },
            { image: require('@/assets/img/profession/service4.png') },
            { image: require('@/assets/img/profession/service5.png') },
            { image: require('@/assets/img/profession/service6.png') },
            { image: require('@/assets/img/profession/service7.png') },
            { image: require('@/assets/img/profession/service8.png') },
            { image: require('@/assets/img/profession/service9.png') },
          ],
        },
        {
          banner: require('@/assets/img/profession/banner2.png'),
          list: [
            { image: require('@/assets/icons/ic_rectangle@2x.png') },
            { image: require('@/assets/icons/ic_triangle@2x.png') },
            { image: require('@/assets/icons/ic_oval@2x.png') },
            { image: require('@/assets/icons/ic_polygon@2x.png') },
            { image: require('assets/icons/ic_rectangle@2x(1).png') },
            { image: require('@/assets/icons/ic_semicircle@2x.png') },
          ],
        },
        {
          banner: require('@/assets/img/profession/banner3.png'),
          list: [
            { image: require('@/assets/icons/ic_rectangle@2x.png') },
            { image: require('@/assets/icons/ic_polygon@2x.png') },
            { image: require('@/assets/icons/ic_oval@2x.png') },
            { image: require('@/assets/icons/ic_semicircle@2x.png') },
          ],
        },
        {
          banner: require('@/assets/img/profession/banner5.png'),
          bannerSub: require('@/assets/img/profession/banner4.png'),
          list: [],
        },
        {
          banner: require('@/assets/img/profession/banner6.png'),
          list: [
            { image: require('@/assets/img/profession/talking_pen.png') },
            { image: require('@/assets/img/profession/dinosaur.png') },
          ],
        },
      ]

      list = this.$t('profession.list').map((item, index) => {
        return {
          ...item,
          ...list[index],
          list: item.list.map((childItem, childIndex) => {
            return {
              ...childItem,
              ...list[index].list[childIndex],
            }
          }),
        }
      })
      // 结合语言版本进行初始化数据
      return list
    },
  },
  beforeMount () {
    setTitle(`${this.$t('home.logo')} - ${this.$t('profession.title')}`)
  },
}
</script>
